.eg{padding:0.5rem;}